import { render, staticRenderFns } from "./News_details.vue?vue&type=template&id=f6389096&scoped=true&"
import script from "./News_details.vue?vue&type=script&lang=js&"
export * from "./News_details.vue?vue&type=script&lang=js&"
import style0 from "./News_details.vue?vue&type=style&index=0&id=f6389096&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6389096",
  null
  
)

export default component.exports